import { Injectable } from '@angular/core';
import { ModalService } from './modal.service';
import { LogService } from './log.service';
import { MessageService } from './message.service';
import { ErrorsDialogComponent } from '../components/errors-dialog/errors-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ErrorsDialogService {
  constructor(
    private modal: ModalService,
    private log: LogService,
    private message: MessageService
  ) {}

  open(errors: string[]) {
    this.modal.open(ErrorsDialogComponent);
    this.message.postMessage({
      type: 'errors-dialog',
      errors
    });
  }
}
